import { rootApi } from '../rootApi';

export const vehicleServiceReportApi = rootApi.injectEndpoints({
    endpoints: (builder) => ({
        getVehicleServiceReport: builder.query({
            query: (body = {}) => ({
                url: 'v1/vehicleservicereport/getlist',
                method: 'POST',
                body: {
                    pageSize: body?.pageSize ?? 20,
                    pageNumber: body?.pageNumber ?? 1,
                    filters: body?.filters ?? null,
                    sorts: body?.sorts ?? null,
                    compressionType: 0
                }
            }),
            transformResponse: (response) => {
                if (response?.data && Array.isArray(response.data.items)) {
                    return {
                        items: response.data.items,
                        totalCount: response.data.totalCount ?? 0,
                        filterOptions: response.data.filterOptions ?? null
                    };
                }
                return { items: [], totalCount: 0, filterOptions: null };
            },
            providesTags: ['VehicleServiceReport']
        }),

        exportVehicleServiceToExcel: builder.query({
            query: (body = {}) => ({
                url: 'v1/vehicleservicereport/exporttoexcel',
                method: 'POST',
                body: {
                    filters: body?.filters ?? null,
                    sorts: body?.sorts ?? null,
                    compressionType: 0
                }
            }),
            transformResponse: (response) => {
                if (response?.isSuccessful && response?.data) {
                    return response.data;
                }
                return { fileBase64: null, error: true };
            }
        })
    }),
    overrideExisting: false
});

export const {
    useGetVehicleServiceReportQuery,
    useLazyExportVehicleServiceToExcelQuery
} = vehicleServiceReportApi;